import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ltcs-schedule-probe-page" }
const _hoisted_2 = { class: "lsp-card" }
const _hoisted_3 = {
  key: 0,
  class: "lsp-warn"
}
const _hoisted_4 = { class: "lsp-card" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "lsp-picked"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "lsp-hint"
}
const _hoisted_9 = {
  key: 2,
  class: "lsp-hint"
}
const _hoisted_10 = { class: "lsp-card" }
const _hoisted_11 = { class: "lsp-pair" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "lsp-pair lsp-pair-gap" }
const _hoisted_15 = { class: "lsp-time" }
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "lsp-time" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "lsp-branch"
}
const _hoisted_22 = {
  key: 1,
  class: "lsp-steps"
}
const _hoisted_23 = {
  key: 2,
  class: "lsp-branch lsp-branch-restore"
}
const _hoisted_24 = {
  key: 3,
  class: "lsp-hint"
}
const _hoisted_25 = {
  key: 4,
  class: "lsp-steps"
}
const _hoisted_26 = { class: "lsp-actions" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 1,
  class: "lsp-card"
}
const _hoisted_31 = { class: "lsp-job-row" }
const _hoisted_32 = { class: "lsp-job" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 0,
  class: "lsp-hint"
}
const _hoisted_35 = {
  key: 1,
  class: "lsp-modal-table"
}
const _hoisted_36 = { class: "lsp-table-title" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "lsp-modal-scroll" }
const _hoisted_39 = { class: "lsp-modal-table" }
const _hoisted_40 = {
  key: 2,
  class: "lsp-hint"
}
const _hoisted_41 = {
  key: 3,
  class: "lsp-logs"
}
const _hoisted_42 = {
  key: 4,
  class: "lsp-warn"
}
const _hoisted_43 = {
  key: 2,
  class: "lsp-hint"
}
const _hoisted_44 = {
  key: 3,
  class: "lsp-hint"
}

import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { ltcsScheduleProbeApi } from '@/services/api'
import LtcsPaymtModalReplica from './LtcsPaymtModalReplica.vue'

type MemberRow = {
  mCode: string
  name: string
  longtermCode?: string
  hasCert: boolean
  label: string
}

type ScheduleRow = {
  clspIdx: number
  date: string
  start: string
  end: string
  caregiverName: string
  recipientName: string
  recipientCert: string
  feeName?: string | null
  label: string
}

type ModalSummary = {
  name?: string
  certNo?: string
  qualification?: string
  validTerm?: string
  contractTerm?: string
}

type ScheduleGrid = {
  headers: string[]
  rows: string[][]
}

type ScheduleMonth = ScheduleGrid & {
  label: string
}

type JobRow = {
  cmqIdx: number
  status: string
  progress?: string | null
  resultMessage?: string | null
  errorMessage?: string | null
  modalSummary?: ModalSummary | null
  scheduleGrid?: ScheduleGrid | null
  scheduleMonths?: ScheduleMonth[] | null
  debugPort?: number | null
  logs?: string[]
}

const DEFAULT_MONTH = '2026-09'
const DEFAULT_MEMBER = '혜봄'

const serverTestHint = '서버 IP가 롱텀케어에 일시 차단되면 실패합니다. 지금은 PC 요청을 쓰세요.'


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsScheduleProbePage',
  setup(__props) {

const addOneDay = (dateKey: string) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey)
  if (!m) return ''
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
  d.setDate(d.getDate() + 1)
  const y = d.getFullYear()
  const mo = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${mo}-${day}`
}

const timeKey = (hm: string) => {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(hm || '').trim())
  if (!m) return ''
  const h = Number(m[1])
  const min = Number(m[2])
  if (h > 23 || min > 59) return ''
  return `${String(h).padStart(2, '0')}:${m[2]}`
}

/** 그 달 30일 일정 중 종료가 가장 늦은 건. 30일이 없으면 고르지 않는다. */
const pickDefaultSchedule = (rows: ScheduleRow[]) => {
  const on30 = rows.filter((row) => String(row.date || '').endsWith('-30'))
  if (!on30.length) return null
  return on30.slice().sort((a, b) => {
    const end = timeKey(b.end).localeCompare(timeKey(a.end))
    if (end) return end
    return timeKey(b.start).localeCompare(timeKey(a.start))
  })[0]
}

const addOneHour = (hm: string) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hm || '').trim())
  if (!m) return ''
  const total = (Number(m[1]) * 60 + Number(m[2]) + 60) % (24 * 60)
  const h = Math.floor(total / 60)
  const min = total % 60
  return `${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}`
}

const normalizeTime = (value: string) => {
  const m = String(value || '').trim().match(/^(\d{1,2}):(\d{2})$/)
  if (!m) return value
  const h = Number(m[1])
  const min = Number(m[2])
  if (h > 23 || min > 59) return value
  return `${String(h).padStart(2, '0')}:${m[2]}`
}

const seoulNow = () => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date())
  const pick = (type: string) => parts.find((part) => part.type === type)?.value || ''
  const hour = pick('hour') === '24' ? '00' : pick('hour')
  return { date: `${pick('year')}-${pick('month')}-${pick('day')}`, time: `${hour}:${pick('minute')}` }
}

const slotEnded = (dateKey: string, startHm: string, endHm: string, now: { date: string, time: string }) => {
  if (!dateKey) return false
  if (!endHm || !now.time) return dateKey < now.date
  const endDate = startHm && endHm < startHm ? nextDateKey(dateKey) : dateKey
  return `${now.date} ${now.time}` > `${endDate} ${endHm}`
}

const nextDateKey = (dateKey: string) => {
  const [y, m, d] = dateKey.split('-').map(Number)
  const dt = new Date(Date.UTC(y, m - 1, d + 1))
  const mm = String(dt.getUTCMonth() + 1).padStart(2, '0')
  const dd = String(dt.getUTCDate()).padStart(2, '0')
  return `${dt.getUTCFullYear()}-${mm}-${dd}`
}

const yearMonthLabel = (dateKey: string) => {
  const matched = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey)
  if (!matched) return ''
  return `${matched[1]}년 ${Number(matched[2])}월`
}

/** schedulePlanProbe.buildChangePlan 과 같은 갈래 문구 */
const describeChange = (input: {
  beforeDate: string
  afterDate: string
  origStart: string
  origEnd: string
  afterStart: string
  afterEnd: string
}) => {
  const now = seoulNow()
  const beforeDate = String(input.beforeDate || '').slice(0, 10)
  const afterDate = String(input.afterDate || '').slice(0, 10)
  const origStart = timeKey(input.origStart)
  const origEnd = timeKey(input.origEnd)
  const afterStartGiven = String(input.afterStart || '').trim()
  const afterEndGiven = String(input.afterEnd || '').trim()
  const afterStartClock = timeKey(input.afterStart)
  const afterEndClock = timeKey(input.afterEnd)
  if ((afterStartGiven && !afterStartClock) || (afterEndGiven && !afterEndClock)) {
    return {
      title: '변경 후 시간 형식 오류',
      lines: ['변경 후 시간은 14:30처럼 24시간제로 적습니다.'],
    }
  }
  const afterStart = afterStartClock || origStart
  const afterEnd = afterEndClock || origEnd
  const dateChanged = Boolean(beforeDate && afterDate && beforeDate !== afterDate)
  const timeChanged = Boolean(origStart && origEnd && (origStart !== afterStart || origEnd !== afterEnd))
  const beforeEnded = slotEnded(beforeDate, origStart, origEnd, now)
  const afterEnded = slotEnded(afterDate, afterStart, afterEnd, now)
  let kind = '변경 없음'
  if (dateChanged && timeChanged) kind = '일자와 시간 변경'
  else if (dateChanged) kind = '일자만 변경'
  else if (timeChanged) kind = '시간만 변경'
  let whenLabel = '안 끝난 날'
  if (beforeEnded && afterEnded) whenLabel = '끝난 날'
  else if (beforeEnded && !afterEnded) whenLabel = '끝난 날을 빼고 안 끝난 날에 넣기'
  else if (!beforeEnded && afterEnded) whenLabel = '안 끝난 날을 빼고 끝난 날에 넣기'
  if (kind === '변경 없음') {
    return { title: '변경 없음', lines: ['일자와 시간이 같아서 바꿀 칸이 없습니다.'] }
  }
  const beforeMonth = yearMonthLabel(beforeDate)
  const afterMonth = yearMonthLabel(afterDate)
  const dayOf = (dateKey: string) => Number(dateKey.slice(8, 10))
  if (beforeMonth !== afterMonth && timeChanged && beforeEnded) {
    const oldSlot = `${dayOf(beforeDate)}일 ${origStart}~${origEnd}`
    const newSlot = `${dayOf(afterDate)}일 ${afterStart}~${afterEnd}`
    return {
      title: '다른 달 · 끝난 날의 일자와 시간 변경',
      lines: [
        `1단 ${beforeMonth}. 끝난 ${oldSlot}만 이 달 표에서 뺀다`,
        `${beforeMonth} 조회 후 1일 요일이 그 달과 같은지 확인`,
        `${beforeMonth}: 지난일정 수정 → 수정사유 → 수정. 이 해제는 ${beforeMonth}에만 통한다`,
        `${beforeMonth} ${oldSlot} 체크 해제. 시작·종료 칸은 누르지 않는다`,
        `${beforeMonth}: 월금액 재산정`,
        '이 실행은 1단에서 멈춘다. 저장 및 통보 없이 2단 년월을 조회하면 1단 해제가 표에서 빠진다',
        `2단 ${afterMonth}. 넣을 시간은 ${afterStart}~${afterEnd}이고 옛 시간 행은 보지 않는다`,
        `${afterMonth} 조회. 1단의 지난일정 수정은 넘어오지 않는다`,
        afterEnded
          ? `${afterMonth}: 넣을 ${newSlot}도 끝났으므로 지난일정 수정 → 수정사유 → 수정 뒤에 행을 다룬다`
          : `${afterMonth}: 넣을 날은 아직 안 끝났으므로 지난일정 수정 없이 진행`,
        `${afterMonth} ${newSlot} 행이 있으면 그 날만 체크`,
        `${afterMonth} 행이 없으면 입력으로 요양요원과 ${afterStart}~${afterEnd}을 넣은 뒤 그 날만 체크`,
        `${afterMonth}: 월금액 재산정`,
        '체크와 재산정 뒤 저장 및 통보 버튼만 남기고 끝냅니다. 이 버튼은 1단만 공단에 넣습니다.',
      ],
    }
  }
  const steps: { month: string, line: string, past: boolean }[] = [
    {
      month: yearMonthLabel(beforeDate),
      past: beforeEnded,
      line: `${dayOf(beforeDate)}일 ${origStart}~${origEnd} 체크 해제`,
    },
  ]
  if (timeChanged) {
    steps.push({
      month: yearMonthLabel(afterDate),
      past: afterEnded,
      line: `${dayOf(afterDate)}일 ${afterStart}~${afterEnd} 행이 있으면 체크, 없으면 입력으로 행을 만든 뒤 체크`,
    })
  } else {
    steps.push({
      month: yearMonthLabel(afterDate),
      past: afterEnded,
      line: `${dayOf(afterDate)}일 ${origStart}~${origEnd} 체크. 그 시간 행이 없으면 입력으로 만든 뒤 체크`,
    })
  }
  const lines: string[] = []
  const months: string[] = []
  steps.forEach((step) => {
    if (!months.includes(step.month)) months.push(step.month)
  })
  months.forEach((month) => {
    const mine = steps.filter((step) => step.month === month)
    lines.push(mine.some((step) => step.past)
      ? `${month}: 지난일정 수정 → 수정사유 → 수정`
      : `${month}: 지난일정 수정 없이 날짜 칸만 변경`)
    mine.forEach((step) => lines.push(`${month} ${step.line}`))
    lines.push(`${month}: 월금액 재산정`)
  })
  if (beforeMonth !== afterMonth) {
    lines.push('이 실행은 앞 달 체크 뒤 저장 및 통보 버튼만 남기고 멈춘다. 다음 달을 조회하면 앞 달 수정이 표에서 빠진다')
  }
  lines.push(beforeMonth !== afterMonth
    ? '저장 및 통보 버튼만 남기고 끝냅니다. 이 버튼은 앞 달만 공단에 넣습니다.'
    : '체크와 재산정 뒤 저장 및 통보 버튼만 남기고 끝냅니다.')
  return { title: `${whenLabel} · ${kind}`, lines }
}

const describeRestore = (date: string, start: string, end: string) => {
  const now = seoulNow()
  const day = date.slice(0, 10)
  const startHm = timeKey(start)
  const endHm = timeKey(end)
  if (!day || !startHm || !endHm || startHm >= endHm) return null
  const ended = slotEnded(day, startHm, endHm, now)
  const month = yearMonthLabel(day)
  const slot = `${Number(day.slice(8, 10))}일 ${startHm}~${endHm}`
  const lines = [`${month} 조회 후 1일 요일이 그 달과 같은지 확인`]
  lines.push(ended
    ? `${month}: 지난일정 수정 → 수정사유 → 수정`
    : `${month}: 지난일정 수정 없이 날짜 칸만 체크`)
  lines.push(`${month} ${slot} 다시 체크. 그 시간 행이 없으면 입력으로 만든 뒤 체크`)
  lines.push(`${month}: 월금액 재산정`)
  lines.push('다른 날 체크는 해제하지 않습니다.')
  lines.push('체크와 재산정 뒤 저장 및 통보 버튼만 남기고 끝냅니다.')
  return { title: '원래 일정 다시 체크', lines }
}

const mCode = ref<string | null>(null)
const members = ref<MemberRow[]>([])
const memberLoading = ref(false)
const scheduleMonth = ref(DEFAULT_MONTH)
const schedules = ref<ScheduleRow[]>([])
const scheduleLoading = ref(false)
const clspIdx = ref<number | null>(null)
const afterDate = ref('')
const afterStart = ref('')
const afterEnd = ref('')
const starting = ref<'' | 'server' | 'pc' | 'restore'>('')
const stopping = ref(false)
const message = ref('')
const isError = ref(false)
const job = ref<JobRow | null>(null)
let searchTimer: ReturnType<typeof setTimeout> | null = null
let pollTimer: ReturnType<typeof setInterval> | null = null
let bootstrapping = true

const picked = computed(() => members.value.find((m) => m.mCode === mCode.value) || null)
const pickedSchedule = computed(() => schedules.value.find((s) => s.clspIdx === clspIdx.value) || null)
const changeBranch = computed(() => {
  const row = pickedSchedule.value
  if (!row?.date || !afterDate.value || !afterStart.value || !afterEnd.value) return null
  return describeChange({
    beforeDate: row.date,
    afterDate: afterDate.value,
    origStart: row.start,
    origEnd: row.end,
    afterStart: afterStart.value,
    afterEnd: afterEnd.value,
  })
})
const restoreBranch = computed(() => {
  const row = pickedSchedule.value
  if (!row?.date || !row.start || !row.end) return null
  return describeRestore(row.date, row.start, row.end)
})
const canStart = computed(() =>
  Boolean(
    mCode.value
    && picked.value?.hasCert
    && pickedSchedule.value?.recipientCert
    && afterDate.value
    && afterStart.value
    && afterEnd.value
  )
)
const canRestore = computed(() =>
  Boolean(mCode.value && picked.value?.hasCert && pickedSchedule.value?.date)
)

const statusLabel = computed(() => {
  const s = job.value?.status || ''
  if (s === 'pending') return '대기 중'
  if (s === 'running' || s === 'processing') return '진행 중'
  if (s === 'completed') return '완료'
  if (s === 'failed') return '실패'
  if (s === 'cancelled') return '취소'
  return s || '-'
})

const isJobActive = computed(() =>
  ['pending', 'processing', 'running'].includes(job.value?.status || '')
)

const isServerJob = computed(() => Boolean(job.value?.debugPort))

const scheduleTables = computed(() => {
  const months = job.value?.scheduleMonths
  if (Array.isArray(months) && months.length) {
    return months.filter((month) => month.headers?.length)
  }
  const grid = job.value?.scheduleGrid
  if (grid?.headers?.length) {
    return [{ label: '', headers: grid.headers, rows: grid.rows || [] }]
  }
  return []
})

const screenPageUrl = `${window.location.origin}/ltcs-schedule-screen`

const onSearch = (q: string) => {
  if (bootstrapping) return
  const selected = picked.value
  if (selected && q && (q.includes(selected.name) || selected.label.startsWith(q))) return
  if (searchTimer) clearTimeout(searchTimer)
  searchTimer = setTimeout(() => loadMembers(q || ''), 250)
}

const loadMembers = async (search: string) => {
  memberLoading.value = true
  try {
    const res = await ltcsScheduleProbeApi.searchMembers(search)
    const rows = (res.data?.data || []) as Array<{
      mCode: string
      name: string
      longtermCode?: string
      hasCert: boolean
    }>
    members.value = rows.map((r) => ({
      ...r,
      label: `${r.name}${r.longtermCode ? ` · ${r.longtermCode}` : ''}${r.hasCert ? '' : ' · 인증서 없음'}`,
    }))
  } catch (e: any) {
    isError.value = true
    message.value = e?.response?.data?.message || '기관 검색에 실패했습니다.'
  } finally {
    memberLoading.value = false
  }
}

const loadSchedules = async () => {
  schedules.value = []
  clspIdx.value = null
  afterDate.value = ''
  afterStart.value = ''
  afterEnd.value = ''
  if (!mCode.value || !picked.value?.hasCert || !scheduleMonth.value) return
  scheduleLoading.value = true
  try {
    const ym = scheduleMonth.value.replace('-', '')
    const res = await ltcsScheduleProbeApi.listSchedules(mCode.value, ym)
    const rows = (res.data?.data || []) as Array<Omit<ScheduleRow, 'label'>>
    schedules.value = rows.map((r) => ({
      ...r,
      label: `${r.caregiverName || '요양보호사'} · ${r.date} ${r.start}~${r.end} · ${r.recipientName || '수급자'}`,
    }))
    clspIdx.value = pickDefaultSchedule(schedules.value)?.clspIdx ?? null
  } catch (e: any) {
    isError.value = true
    message.value = e?.response?.data?.message || '일정을 불러오지 못했습니다.'
  } finally {
    scheduleLoading.value = false
  }
}

watch([mCode, scheduleMonth], () => {
  loadSchedules()
})
watch(clspIdx, () => {
  const row = pickedSchedule.value
  afterDate.value = row?.date ? addOneDay(row.date) : ''
  afterStart.value = row?.start ? addOneHour(row.start) : ''
  afterEnd.value = row?.end ? addOneHour(row.end) : ''
})

const stopPoll = () => {
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
}

const pullJob = async () => {
  if (!job.value) return
  try {
    const res = await ltcsScheduleProbeApi.getJob(job.value.cmqIdx)
    job.value = res.data?.data || job.value
    const st = job.value?.status
    if (st === 'completed' || st === 'failed' || st === 'cancelled') stopPoll()
  } catch (e: any) {
    if (e?.response?.status === 404) {
      // 서버 재시작으로 작업 정보가 사라진 경우
      stopPoll()
      job.value = {
        ...job.value,
        status: 'failed',
        errorMessage: '서버 재시작으로 작업이 중단되었습니다. 다시 시작해 주세요.',
      }
    }
  }
}

const start = async (mode: 'server' | 'pc' | 'restore') => {
  const restore = mode === 'restore'
  if (restore) {
    if (!canRestore.value || !mCode.value || !clspIdx.value) return
  } else if (!canStart.value || !mCode.value || !clspIdx.value) return
  starting.value = mode
  isError.value = false
  message.value = ''
  stopPoll()
  try {
    const body = {
      mCode: mCode.value,
      afterDate: afterDate.value,
      afterStart: afterStart.value,
      afterEnd: afterEnd.value,
      clspIdx: clspIdx.value,
      restore,
    }
    const res = mode === 'server'
      ? await ltcsScheduleProbeApi.startServerTest(body)
      : await ltcsScheduleProbeApi.startTest(body)
    if (!res.data?.success) throw new Error(res.data?.message || '등록 실패')
    const cmqIdx = Number(res.data?.data?.cmqIdx)
    job.value = {
      cmqIdx,
      status: res.data?.data?.status || (mode === 'server' ? 'running' : 'pending'),
      progress: res.data?.data?.progress || null,
      debugPort: res.data?.data?.debugPort || null,
      logs: res.data?.data?.logs || [],
    }
    if (mode === 'server') {
      window.open(screenPageUrl, 'ltcsProbeScreen', 'width=1460,height=960')
    }
    message.value = res.data?.message || '테스트를 등록했습니다.'
    await pullJob()
    pollTimer = setInterval(pullJob, 3000)
  } catch (e: any) {
    isError.value = true
    message.value = e?.response?.data?.message || e?.message || '테스트 등록에 실패했습니다.'
  } finally {
    starting.value = ''
  }
}

const stopJob = async () => {
  if (!job.value || !isJobActive.value || stopping.value) return
  stopping.value = true
  try {
    const res = await ltcsScheduleProbeApi.stopJob(job.value.cmqIdx)
    if (res.data?.data) job.value = res.data.data
    stopPoll()
  } catch (e: any) {
    isError.value = true
    message.value = e?.response?.data?.message || '중단에 실패했습니다.'
  } finally {
    stopping.value = false
  }
}

const loadCurrentJob = async () => {
  try {
    const res = await ltcsScheduleProbeApi.getCurrent()
    const current = res.data?.data
    if (!current) return
    job.value = current
    if (['pending', 'processing', 'running'].includes(current.status)) {
      stopPoll()
      pollTimer = setInterval(pullJob, 3000)
    }
  } catch {
    /* 현재 작업 조회 실패는 무시 */
  }
}

onBeforeUnmount(stopPoll)
loadMembers(DEFAULT_MEMBER).finally(() => {
  const hit = members.value.find((m) => m.name.includes(DEFAULT_MEMBER) && m.hasCert)
    || members.value.find((m) => m.name.includes(DEFAULT_MEMBER))
  if (hit) mCode.value = hit.mCode
  bootstrapping = false
})
loadCurrentJob()

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("header", { class: "lsp-header" }, [
      _createElementVNode("h2", { class: "lsp-title" }, "일정계획 변경 테스트"),
      _createElementVNode("p", { class: "lsp-sub" }, "권한 100 전용 · PC 매크로 매니저로 일정계획 변경 테스트를 요청합니다")
    ], -1)),
    _createVNode(LtcsPaymtModalReplica, {
      "year-month": scheduleMonth.value || '2026-09',
      summary: job.value?.modalSummary || null,
      grid: scheduleTables.value[0] || null
    }, null, 8, ["year-month", "summary", "grid"]),
    _createElementVNode("section", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "lsp-label" }, "기관", -1)),
      _createVNode(_component_v_autocomplete, {
        modelValue: mCode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mCode).value = $event)),
        items: members.value,
        loading: memberLoading.value,
        "item-title": "label",
        "item-value": "mCode",
        placeholder: "기관명·기관기호 검색",
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        clearable: "",
        "no-filter": "",
        "onUpdate:search": onSearch
      }, null, 8, ["modelValue", "items", "loading"]),
      (picked.value && !picked.value.hasCert)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "롱텀케어 인증서가 없습니다."))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "lsp-label" }, "일정 월", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((scheduleMonth).value = $event)),
        class: "lsp-input",
        type: "month",
        disabled: !mCode.value || !picked.value?.hasCert
      }, null, 8, _hoisted_5), [
        [_vModelText, scheduleMonth.value]
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "lsp-label lsp-label-gap" }, "요양보호사 일정", -1)),
      _createVNode(_component_v_autocomplete, {
        modelValue: clspIdx.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((clspIdx).value = $event)),
        items: schedules.value,
        loading: scheduleLoading.value,
        disabled: !mCode.value || !picked.value?.hasCert,
        "item-title": "label",
        "item-value": "clspIdx",
        placeholder: "요양보호사 · 날짜 · 시간 · 수급자",
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        clearable: "",
        "no-data-text": "이 달에 일정이 없습니다"
      }, null, 8, ["modelValue", "items", "loading", "disabled"]),
      (pickedSchedule.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createTextVNode(" 수급자 " + _toDisplayString(pickedSchedule.value.recipientName || '이름 없음') + " ", 1),
            (pickedSchedule.value.recipientCert)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, " · " + _toDisplayString(pickedSchedule.value.recipientCert), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (pickedSchedule.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(pickedSchedule.value.caregiverName), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_9, "일정을 고르면 그 일정의 수급자가 같이 선택됩니다."))
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "lsp-label" }, "변경 전 일자", -1)),
          _createElementVNode("input", {
            class: "lsp-input is-readonly",
            type: "text",
            readonly: "",
            value: pickedSchedule.value?.date || ''
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("div", null, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "lsp-label" }, "변경 후 일자", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((afterDate).value = $event)),
            class: "lsp-input",
            type: "date",
            disabled: !pickedSchedule.value
          }, null, 8, _hoisted_13), [
            [_vModelText, afterDate.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", null, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "lsp-label" }, "변경 전 시간", -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("input", {
              class: "lsp-input is-readonly",
              type: "text",
              readonly: "",
              value: pickedSchedule.value?.start || ''
            }, null, 8, _hoisted_16),
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "lsp-tilde" }, "~", -1)),
            _createElementVNode("input", {
              class: "lsp-input is-readonly",
              type: "text",
              readonly: "",
              value: pickedSchedule.value?.end || ''
            }, null, 8, _hoisted_17)
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "lsp-label" }, "변경 후 시간", -1)),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((afterStart).value = $event)),
              class: "lsp-input",
              type: "text",
              inputmode: "numeric",
              maxlength: "5",
              placeholder: "15:30",
              disabled: !pickedSchedule.value,
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (afterStart.value = normalizeTime(afterStart.value)))
            }, null, 40, _hoisted_19), [
              [_vModelText, afterStart.value]
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "lsp-tilde" }, "~", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((afterEnd).value = $event)),
              class: "lsp-input",
              type: "text",
              inputmode: "numeric",
              maxlength: "5",
              placeholder: "15:30",
              disabled: !pickedSchedule.value,
              onBlur: _cache[7] || (_cache[7] = ($event: any) => (afterEnd.value = normalizeTime(afterEnd.value)))
            }, null, 40, _hoisted_20), [
              [_vModelText, afterEnd.value]
            ])
          ])
        ])
      ]),
      (changeBranch.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(changeBranch.value.title), 1))
        : _createCommentVNode("", true),
      (changeBranch.value)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeBranch.value.lines, (line, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(line), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _cache[20] || (_cache[20] = _createElementVNode("p", { class: "lsp-hint" }, "변경 후 일자는 다음 날이고, 변경 후 시간은 변경 전보다 1시간 뒤입니다. 시간은 14:30처럼 표시됩니다.", -1)),
      (restoreBranch.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(restoreBranch.value.title), 1))
        : _createCommentVNode("", true),
      (restoreBranch.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_24, "저장 및 통보를 누르지 않으면 공단 일정은 그대로입니다. 눌렀다면 이 실행에서 빠지는 것은 선택한 날의 체크뿐이고, 10월 일정은 넣지 않습니다. 아래는 그 체크를 다시 넣는 순서입니다."))
        : _createCommentVNode("", true),
      (restoreBranch.value)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(restoreBranch.value.lines, (line, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: 'restore-' + index
              }, _toDisplayString(line), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("button", {
        type: "button",
        class: "lsp-btn",
        disabled: !canStart.value || !!starting.value || isJobActive.value,
        onClick: _cache[8] || (_cache[8] = ($event: any) => (start('pc')))
      }, _toDisplayString(starting.value === 'pc' ? '요청 중…' : '일정계획 변경 테스트 요청'), 9, _hoisted_27),
      _createElementVNode("button", {
        type: "button",
        class: "lsp-btn lsp-btn-sub",
        disabled: !canStart.value || !!starting.value || isJobActive.value,
        title: serverTestHint,
        onClick: _cache[9] || (_cache[9] = ($event: any) => (start('server')))
      }, _toDisplayString(starting.value === 'server' ? '시작 중…' : '서버에서 바로 테스트'), 9, _hoisted_28),
      _createElementVNode("button", {
        type: "button",
        class: "lsp-btn lsp-btn-restore",
        disabled: !canRestore.value || !!starting.value || isJobActive.value,
        onClick: _cache[10] || (_cache[10] = ($event: any) => (start('restore')))
      }, _toDisplayString(starting.value === 'restore' ? '요청 중…' : '원래 일정 다시 체크'), 9, _hoisted_29)
    ]),
    _cache[26] || (_cache[26] = _createElementVNode("p", { class: "lsp-hint" }, " 요청하면 큐에 등록되고, PC에서 폴링 중인 매크로 매니저가 가져가 크롬으로 실행합니다. (서버 테스트는 이 서버 IP가 롱텀케어에 막혀 있으면 실패할 수 있습니다.) ", -1)),
    (message.value)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["lsp-msg", { 'is-error': isError.value }])
        }, _toDisplayString(message.value), 3))
      : _createCommentVNode("", true),
    (job.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("p", _hoisted_32, "작업 " + _toDisplayString(job.value.cmqIdx) + " · " + _toDisplayString(statusLabel.value), 1),
            (isJobActive.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "lsp-stop",
                  disabled: stopping.value,
                  onClick: stopJob
                }, _toDisplayString(stopping.value ? '중단 중…' : '중단'), 9, _hoisted_33))
              : _createCommentVNode("", true)
          ]),
          (job.value.progress)
            ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(job.value.progress), 1))
            : _createCommentVNode("", true),
          (job.value.modalSummary)
            ? (_openBlock(), _createElementBlock("table", _hoisted_35, [
                _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "성명"),
                    _createElementVNode("th", null, "장기요양인정번호"),
                    _createElementVNode("th", null, "자격"),
                    _createElementVNode("th", null, "인정유효기간"),
                    _createElementVNode("th", null, "계약기간")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(job.value.modalSummary.name || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(job.value.modalSummary.certNo || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(job.value.modalSummary.qualification || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(job.value.modalSummary.validTerm || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(job.value.modalSummary.contractTerm || '-'), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduleTables.value, (month, mi) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `m-${mi}`
            }, [
              _createElementVNode("p", _hoisted_36, [
                _cache[22] || (_cache[22] = _createTextVNode("급여일정등록·변경", -1)),
                (month.label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, " · " + _toDisplayString(month.label), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("table", _hoisted_39, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.headers, (header, hi) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: `h-${mi}-${hi}`
                        }, _toDisplayString(header), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.rows, (row, ri) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: `r-${mi}-${ri}`
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, ci) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: `c-${mi}-${ri}-${ci}`
                          }, _toDisplayString(cell), 1))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ], 64))
          }), 128)),
          (job.value.resultMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(job.value.resultMessage), 1))
            : _createCommentVNode("", true),
          (job.value.logs && job.value.logs.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.value.logs, (line, idx) => {
                  return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(line), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (job.value.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(job.value.errorMessage), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (job.value && isJobActive.value && !isServerJob.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_43, " PC에 켜 둔 매크로 매니저가 작업을 가져가면, 그 PC에 크롬 창이 열리며 진행됩니다. "))
      : _createCommentVNode("", true),
    (job.value && isServerJob.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
          _cache[23] || (_cache[23] = _createTextVNode(" 서버 브라우저 화면이 안 떴으면 ", -1)),
          _createElementVNode("a", {
            class: "lsp-link",
            href: screenPageUrl,
            target: "_blank",
            rel: "noopener"
          }, "여기를 눌러"),
          _cache[24] || (_cache[24] = _createTextVNode(" 열어 주세요. ", -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})